import { apiFetch } from "./client";

export function getCheckoutSummary(userId, addressId) {
  const qs = addressId ? `?addressId=${encodeURIComponent(addressId)}` : "";
  return apiFetch(`/api/users/${encodeURIComponent(userId)}/orders/checkout${qs}`);
}

export function getOrders(userId, page = 1, pageSize = 10) {
  const qs = new URLSearchParams({
    Page: String(page),
    PageSize: String(pageSize),
  });
  return apiFetch(`/api/users/${encodeURIComponent(userId)}/orders?${qs}`);
}

export function getOrder(userId, orderId) {
  return apiFetch(
    `/api/users/${encodeURIComponent(userId)}/orders/${encodeURIComponent(orderId)}`
  );
}

export function placeOrder(userId, body) {
  return apiFetch(`/api/user/${encodeURIComponent(userId)}/order`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function cancelUserOrder(userId, orderId) {
  return apiFetch(
    `/api/users/${encodeURIComponent(userId)}/orders/${encodeURIComponent(orderId)}/cancel`,
    {
      method: "POST",
    }
  );
}

